import { createAction, props } from '@ngrx/store';
import {SpesenartItem} from '../../spesenart.model';

export const loadSpesenartenStart = createAction('ZEIT::SPESENARTEN_LOAD_START');
export const loadSpesenartenSucceeded = createAction(
    'ZEIT::SPESENARTEN_LOAD_SUCCEEDED',
    props<{ item: SpesenartItem[] }>(),
);
export const loadSpesenartenFailed = createAction('ZEIT::SPESENARTEN_LOAD_FAILED',
  props<{ error: Error }>());
